import { Component, Input, } from '@angular/core';
import { HostListenerService } from '../../../../services/host-listener.service';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ButtonSpacerDirective } from '../directives/button.directive';
import { AvatarBlockModule } from '../avatar-block/avatar-block.module';

@Component({
    standalone: true,
    imports: [
        MatButtonModule,
        AsyncPipe,
        MatIconModule,
        NgIf,
        ButtonSpacerDirective,
        NgTemplateOutlet,
        AvatarBlockModule,
    ],
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent
{
    @Input() avatarHeader = false;
    @Input() loadingInitialData = false;
    @Input() useInlineHeader = false;
    @Input() svg: string;
    @Input() initials: string;

    constructor (
            private _host: HostListenerService,
    ) {
    }

    get tabletMode$() {
        return this._host.isTabletMode();
    }
}
